import {bindable} from 'aurelia-framework';

export class HtmlEditor {   
    encoded = false;
	saveEdit() {
        this.save();       
    }

	create() {
		const rteObj = $("#htmlEditor").ejRTE("instance");
		// You can customize the isUrl function based on your scenario. 
		rteObj._isUrl = function (url: string) {			
			return url !== "";
		} 
	}

    @bindable save: Function;
    @bindable cancel: Function;
    @bindable entity;
}